function headerLp1() {
    if (!document.body.classList.contains('page-template-template-lp-1')) return;

    const header = document.getElementById('navbar-container');
    if (!header) return;

    let lastScrollY = 0;
    let ticking = false;

    function update() {
        const currentScrollY = window.scrollY;
        const headerHeight = header.offsetHeight;

        if (currentScrollY > headerHeight) {
            header.classList.add('header--scrolled');
        } else {
            header.classList.remove('header--scrolled');
        }

        if (currentScrollY > lastScrollY && currentScrollY > headerHeight) {
            header.classList.add('header--hidden');
        } else if (currentScrollY < lastScrollY) {
            header.classList.remove('header--hidden');
        }

        lastScrollY = currentScrollY;
        ticking = false;
    }

    window.addEventListener('scroll', () => {
        if (!ticking) {
            requestAnimationFrame(update);
            ticking = true;
        }
    }, { passive: true });
}

export { headerLp1 }
